import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { KRegistNumberForm } from "src/components/common/form/input/KRegistNumberForm";
import { useSYS3050_R01Store } from "src/containers/mes/SYS/SYS3050_R01/Store_SYS3050_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";

import { BRDiv, inputAddressMRClass } from "src/components/common/common";
import { AddressForm } from "src/components/common/form/address/AddressForm";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { AddressJusoDto } from "src/dtos/address/addressApiResponseDto";
import { handleKeyDown, syntheticEvent } from "src/utils/commonForm/commonFormUtils";
import { formatDate, formatPhoneNumber } from "src/utils/string/stringUtil";

import { defaultSYS3050_R01Dto, SYS3050_R01Dto } from "./Dto_SYS3050_R01";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { getOrganizationList } from "src/apis/organizaApi";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

// 퇴사일자 처리 유틸리티 함수
const getRetireDateValue = (retireDt: string | undefined): Date | undefined => {
	if (!retireDt) return undefined;
	const retireDate = new Date(retireDt);
	// 9999-12-31이거나 유효하지 않은 날짜인 경우 undefined 반환
	if (retireDate.getFullYear() === 9999 && retireDate.getMonth() === 11 && retireDate.getDate() === 31) {
		return undefined;
	}
	if (isNaN(retireDate.getTime())) {
		return undefined;
	}
	return retireDate;
};

interface Props {
	defaultSYS3050_R01Row: SYS3050_R01Dto;
}

export const SYS3050_R01Info = (props: Props) => {
	const { defaultSYS3050_R01Row } = props;

	const { selectedSYS3050_R01, editSYS3050_R01, setEditSYS3050_R01 } = useSYS3050_R01Store();
	const { 
		compCdList,
		empstsCdList,
		compJoinTpList,
		jjCdList,
		jwCdList,
		jcCdList,
		payTpList,
		retireTypeList,
		birthdayTypeList,
		countryCdList,
		carTypeList,
		educationTypeList,
		yesNoList,
		orgCdList
	} = useCommonCodeStore();
	const { setCodeSearchModalProps, setAddressModalProps } = useUiuxStore();

	const orgInfoHandleFoucsId = 'infoOrgInput';

	// 입사일자 달력 팝업 상태
	const [empDtPickerVisible, setEmpDtPickerVisible] = useState(false);
	const [empDtPickerPos, setEmpDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	//최종승진일자 달력 팝업 상태
	const [positionDtPickerVisible, setPositionDtPickerVisible] = useState(false);
	const [positionDtPickerPos, setPositionDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	//퇴사일자 달력 팝업 상태
	const [retireDtPickerVisible, setRetireDtPickerVisible] = useState(false);
	const [retireDtPickerPos, setRetireDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	//생일 달력 팝업 상태
	const [birthdayPickerVisible, setBirthdayPickerVisible] = useState(false);
	const [birthdayPickerPos, setBirthdayPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	//퇴직금정산일 달력 팝업 상태
	const [retireInterimDtPickerVisible, setRetireInterimDtPickerVisible] = useState(false);
	const [retireInterimDtPickerPos, setRetireInterimDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});


	const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;
		setEditSYS3050_R01({
			...defaultSYS3050_R01Row,
			...editSYS3050_R01,       
			[name]:  name === 'telNo' || name === 'officeTel' || name === 'officeFax' || name === 'mobileNo' ? formatPhoneNumber(value) : value             
		});
	};

	const handleKRegistNumberChange = (type: string, e: ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		setEditSYS3050_R01({
			...defaultSYS3050_R01Row,
			...editSYS3050_R01,
			[type]: value             
		});
	}
	
	const addressHandleFoucsId = 'addressInput';

	const infoInputStyle = {
		wrapperStyle: "w-[260px] min-w-[260px] mr-[2px] mb-[5px]",
		titleStyle: "w-[100px] min-w-[100px]",
		inputStyle: "w-[150px] min-w-[150px]"
	}

	const infoRegistNumberStyle = {
		...infoInputStyle,
		titleStyle: "w-[100px] min-w-[100px]",
		inputStyle: "w-[70px] min-w-[70px]",
		registNumberStyle: "w-[70px] min-w-[70px]"
	}

	
	const addressWrapperStyle = {
		wrapperStyle: "w-[825px] mr-[10px]",
		postInputStyle: 'w-[50px] min-w-[50px]' + ' ' + inputAddressMRClass,
		buttonStyle: 'px-[12px]' + ' ' + inputAddressMRClass,
		titleStyle: 'w-[100px] min-w-[100px]',
		inputStyle: 'w-[308px] min-w-[308px]',
		detailAddressInputStyle: 'w-[250px] min-w-[250px]',
	}	

	const orgInfoStyle = {
		...infoInputStyle,
		codeInputStyle: "w-[60px] min-w-[60px]",
		custNmInputStyle: "w-[150px] min-w-[150px]"
	}

	const infoBirthdayTypeStyle = {
		...infoInputStyle,
		wrapperStyle: "w-[161px] min-w-[161px] mr-[2px] mb-[5px]",
		inputStyle: "w-[55px] min-w-[55px]"	
	}

	const infoBirthdayStyle = {
		...infoInputStyle,
		wrapperStyle: "w-[91px] min-w-[91px] mr-[8px] mb-[5px]",	
		inputStyle: "w-[91px] min-w-[91px]"	
	}

	const infoCarTypeStyle = {
		...infoInputStyle,
		wrapperStyle: "w-[201px] min-w-[201px] mr-[5px] mb-[5px]",
		inputStyle: "w-[95px] min-w-[95px]"	
	}

	const infoCarInputStyle = {
		...infoInputStyle,
		wrapperStyle: "w-[150px] min-w-[150px] mr-[9px] mb-[5px]",
		inputStyle: "w-[150px] min-w-[150px]"
	}

	const handleAddressSearchClick = () => {
		setAddressModalProps({
			onSelect: (data: AddressJusoDto) => {
				setEditSYS3050_R01({
					...defaultSYS3050_R01Row,
					...editSYS3050_R01,
					post: data.zipNo,
					address: data.roadAddr,
				})
				setAddressModalProps(undefined);
				handleKeyDown(syntheticEvent(addressHandleFoucsId), 'focus');
			},
			handleFoucsId: addressHandleFoucsId // 주소 검색 후 입력 포커스 이동을 위한 아이디
		})
	}

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'orgCd',
			category: '부서',
			focusId: orgInfoHandleFoucsId,
			responseMapping: {
				orgCd: 'orgCd',
				orgNm: 'orgNm',
			},
			searchFunction: async (code: string) => {
				const orgResponse = await getOrganizationList('all');
				return orgResponse.data.data.find(value => value.orgCd === code);
			},
			extraFilter: () => ({
				orgCd: editSYS3050_R01?.orgCd || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: editSYS3050_R01,
		setEditData: setEditSYS3050_R01,
		defaultData: defaultSYS3050_R01Row,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SYS3050_R01_info'
	});


	return (
		<div className="w-full h-full flex flex-col gap-[8px] border border-gray-300 px-[12px] py-[12px] overflow-x-auto overflow-y-auto">
			<div className="w-full h-full flex flex-wrap content-start p-[5px]">
				{/* editSYS3050_R01 : {JSON.stringify(editSYS3050_R01)} <br/> */}
				<InputForm 
					title="사원번호"	name="empNo"	value={editSYS3050_R01?.empNo || ''}		editable={selectedSYS3050_R01 === undefined} 	
					wrapperOption={infoInputStyle}
					onChange={handleChange} 
				/>
				<InputForm 
					title="성명"		name="empNm"	value={editSYS3050_R01?.empNm || ''}		editable={true}	
					wrapperOption={infoInputStyle}
					onChange={handleChange} />
				<DropDownForm 
					title="재직상태"	name="empSts"	initLabelLess={true}	value={editSYS3050_R01?.empSts || ''}		
					wrapperOption={infoInputStyle}
					data={empstsCdList}
					onChange={handleChange} />
				<KRegistNumberForm 
					title="주민등록번호"	name="resnoBirth"	
					forwardValue={ editSYS3050_R01?.resnoBirth || '' }
					backwardValue={ editSYS3050_R01?.resnoLastkey || '' }
					editable={true} 	
					wrapperOption={infoRegistNumberStyle}
					forwardOnChange={(e) => handleKRegistNumberChange('resnoBirth', e)} 
					backwardOnChange={(e) => handleKRegistNumberChange('resnoLastkey', e)} 
				/>
				<InputForm 
					title="성명(한자)"	name="cname"	value={editSYS3050_R01?.cname || ''}		editable={true} 	
					wrapperOption={infoInputStyle}
					onChange={handleChange} 
				/>
				<InputForm 
					title="성명(영업)"	name="ename"	value={editSYS3050_R01?.ename || ''}		editable={true} 	
					wrapperOption={infoInputStyle}
					onChange={handleChange} 
				/>
				<SingleDateForm
					title="입사일자"
					value={editSYS3050_R01?.empDt ? new Date(editSYS3050_R01.empDt) : undefined}	
					setValue={(value: Date | undefined) => setEditSYS3050_R01({ ...defaultSYS3050_R01Row, ...editSYS3050_R01, empDt: value ? formatDate(value) : undefined })}
					editable={true}
					wrapperOption={infoInputStyle}
					visible={empDtPickerVisible}				setVisible={setEmpDtPickerVisible}
					onChange={handleChange}
					pickerPos={empDtPickerPos}					setPickerPos={setEmpDtPickerPos}
				/>
				<DropDownForm
					title="입사구분"	name="compJoinType"		initLabelLess={true}	value={editSYS3050_R01?.compJoinType || ''}		
					wrapperOption={infoInputStyle}
					data={compJoinTpList}
					onChange={handleChange} />
				<InputForm 
					title="출입증No"	name="cardNo"	value={editSYS3050_R01?.cardNo || ''}		editable={true} 	
					wrapperOption={infoInputStyle}
					onChange={handleChange} 
				/>
				<DropDownForm
					title="사업장"	name="compCd"	initLabelLess={true}	value={editSYS3050_R01?.compCd || ''}		
					wrapperOption={infoInputStyle}
					initLabel="비어있음"
					data={compCdList}
					onChange={handleChange} />
				<CodeForm
					label="부서"
					value={editSYS3050_R01?.orgCd || ''}
					custNmValue={orgCdList.find(org => org.orgCd === editSYS3050_R01?.orgCd)?.orgNm || ''}
					handleFoucsId={orgInfoHandleFoucsId}
					name="infoOrgInput"
					codeInputless={true}
					wrapperOption={orgInfoStyle}
					handleChange={getFieldHandlers('orgCd').onChange}
					onDoubleClick={getFieldHandlers('orgCd').onDoubleClick} 
					onKeyDown={getFieldHandlers('orgCd').onEnterKeyDown}
				/>
				<DropDownForm
					title="직종(직군)"	name="jobClass"	initLabelLess={true}	value={editSYS3050_R01?.jobClass || ''}		
					wrapperOption={infoInputStyle}
					initLabel="비어있음"	
					data={jjCdList}
					onChange={handleChange} />
				<DropDownForm
					title="직위"	name="positionCd"	initLabelLess={true}	value={editSYS3050_R01?.positionCd || ''}		
					wrapperOption={infoInputStyle}
					initLabel="비어있음"
					data={jwCdList}
					onChange={handleChange} />
				<DropDownForm
					title="직책"	name="jobPosition"	initLabelLess={true}	value={editSYS3050_R01?.jobPosition || ''}		
					wrapperOption={infoInputStyle}
					initLabel="비어있음"
					data={jcCdList}
					onChange={handleChange} />
				<SingleDateForm
					title="최종 승진일자"
					value={editSYS3050_R01?.positionDt ? new Date(editSYS3050_R01.positionDt) : undefined}	
					setValue={(value: Date | undefined) => setEditSYS3050_R01({ ...defaultSYS3050_R01Row, ...editSYS3050_R01, positionDt: value ? formatDate(value) : undefined })}
					editable={true}
					wrapperOption={infoInputStyle}
					visible={positionDtPickerVisible}				setVisible={setPositionDtPickerVisible}
					onChange={handleChange}
					pickerPos={positionDtPickerPos}						setPickerPos={setPositionDtPickerPos}
				/>
				<DropDownForm
					title="급여구분"	name="payType"	initLabelLess={true}	value={editSYS3050_R01?.payType || ''}		
					wrapperOption={infoInputStyle}
					initLabel="비어있음"
					data={payTpList}
					onChange={handleChange} />
				<SingleDateForm
					title="퇴사일자"
					value={getRetireDateValue(editSYS3050_R01?.retireDt)}	
					setValue={(value: Date | undefined) => setEditSYS3050_R01({ ...defaultSYS3050_R01Row, ...editSYS3050_R01, retireDt: value ? formatDate(value) : undefined })}
					editable={true}
					wrapperOption={infoInputStyle}
					visible={retireDtPickerVisible}				setVisible={setRetireDtPickerVisible}
					onChange={handleChange}
					pickerPos={retireDtPickerPos}						setPickerPos={setRetireDtPickerPos}
					placeholder=""
				/>
				<DropDownForm
				//  title="퇴직사유"    name="retireType"   initLabelLess={true}    value={editSYS3050_R01?.retireType || ''} 
					title="퇴직사유"	name="retireType"	initLabelLess={false}	value={editSYS3050_R01?.retireType || ''}		
					wrapperOption={infoInputStyle}
					initLabel="비어있음"
					data={retireTypeList}
					onChange={handleChange} />

				<AddressForm
					post={editSYS3050_R01?.post || ''}
					address={editSYS3050_R01?.address || ''}
					detailAddress={editSYS3050_R01?.detailAddress || ''}
					handleFoucsId={addressHandleFoucsId}
					onChange={handleChange}
					onSearchClick={handleAddressSearchClick}
					wrapperOption={addressWrapperStyle}
				/>
				<BRDiv />
				<DropDownForm
					title="생일구분"	name="birthdayType"	initLabelLess={true}	value={editSYS3050_R01?.birthdayType || ''}		
					wrapperOption={infoBirthdayTypeStyle}
					initLabel="선택"
					data={birthdayTypeList}
					onChange={handleChange} />
				<SingleDateForm
					title="생일"
					value={editSYS3050_R01?.birthday ? new Date(editSYS3050_R01.birthday) : undefined}	
					setValue={(value: Date | undefined) => setEditSYS3050_R01({ ...defaultSYS3050_R01Row, ...editSYS3050_R01, birthday: value ? formatDate(value) : undefined })}
					editable={true}								titleless={true}
					wrapperOption={infoBirthdayStyle}
					visible={birthdayPickerVisible}				setVisible={setBirthdayPickerVisible}
					onChange={handleChange}
					pickerPos={birthdayPickerPos}				setPickerPos={setBirthdayPickerPos}
				/>
				<DropDownForm
					title="최종학력"	name="educationLevel"	initLabelLess={true}	value={editSYS3050_R01?.educationLevel || ''}		
					wrapperOption={infoInputStyle}
					initLabel="비어있음"
					data={educationTypeList}
					onChange={handleChange} />
				<DropDownForm
					title="국가유공자"	name="meritPersonYn"	initLabelLess={true}	value={editSYS3050_R01?.meritPersonYn || ''}		
					wrapperOption={infoInputStyle}
					initLabel="비어있음"
					data={yesNoList}
					onChange={handleChange} />
				<BRDiv />
				<DropDownForm
					title="차종"	name="carType"	initLabelLess={true}	value={editSYS3050_R01?.carType || ''}		
					wrapperOption={infoCarTypeStyle}
					initLabel="비어있음"
					data={carTypeList}
					onChange={handleChange} />
				<InputForm
					title="차명"	name="carNm"		value={editSYS3050_R01?.carNm || ''}		editable={true} 	titleless={true}
					wrapperOption={infoCarInputStyle}
					onChange={handleChange} 
					placeholder="차명"
				/>
				<InputForm
					title="차량번호"	name="carNo"	value={editSYS3050_R01?.carNo || ''}		editable={true}  titleless={true}	
					wrapperOption={infoCarInputStyle}
					onChange={handleChange} 
					placeholder="차량번호"
				/>
				<BRDiv />
				<DropDownForm
					title="내국인"	name="foreignYn"	initLabelLess={true}	value={editSYS3050_R01?.foreignYn || ''}		
					wrapperOption={infoInputStyle}
					initLabel="비어있음"
					data={yesNoList}
					onChange={handleChange} />
				<DropDownForm
					title="국적"	name="country"		initLabelLess={true}	value={editSYS3050_R01?.country || ''}		
					wrapperOption={infoInputStyle}
					initLabel="비어있음"
					data={countryCdList}
					onChange={handleChange} />
				<SingleDateForm
					title="퇴직금정산일"
					value={editSYS3050_R01?.retireInterimDt ? new Date(editSYS3050_R01.retireInterimDt) : undefined}	
					setValue={(value: Date | undefined) => setEditSYS3050_R01({ ...defaultSYS3050_R01Row, ...editSYS3050_R01, retireInterimDt: value ? formatDate(value) : undefined })}
					editable={true}
					wrapperOption={infoInputStyle}
					visible={retireInterimDtPickerVisible}				setVisible={setRetireInterimDtPickerVisible}
					onChange={handleChange}
					pickerPos={retireInterimDtPickerPos}						setPickerPos={setRetireInterimDtPickerPos}
				/>

				
				<BRDiv />
				<InputForm
					title="이메일"	name="email"	value={editSYS3050_R01?.email || ''}		editable={true} 	
					wrapperOption={infoInputStyle}
					onChange={handleChange} 
				/>
				<InputForm
					title="집전화"	name="telNo"	value={editSYS3050_R01?.telNo || ''}		editable={true} 	
					wrapperOption={infoInputStyle}
					onChange={handleChange} 
				/>
				<InputForm
					title="휴대전화"	name="mobileNo"	value={editSYS3050_R01?.mobileNo || ''}		editable={true} 	
					wrapperOption={infoInputStyle}
					onChange={handleChange} 
				/>
				<InputForm
					title="사무실전화"	name="officeTel"	value={editSYS3050_R01?.officeTel || ''}		editable={true} 	
					wrapperOption={infoInputStyle}
					onChange={handleChange} 
				/>
				<InputForm
					title="사무실팩스"	name="officeFax"	value={editSYS3050_R01?.officeFax || ''}		editable={true} 	
					wrapperOption={infoInputStyle}
					onChange={handleChange} 
				/>
		
			</div>
		</div>
	  )


}
